'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeUniqueRowKey;

var _getFieldValue = require('./getFieldValue');

var _getFieldValue2 = _interopRequireDefault(_getFieldValue);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var rowIndex = 0;
/* eslint-disable no-console */

function computeUniqueRowKey(rowData, keyField) {
  var value = (0, _getFieldValue2.default)(rowData, keyField);

  if (value && typeof value === 'string') {
    return value;
  }

  if (rowIndex === 0) {
    console.error('The "keyField" passed is not valid.');
  }

  rowIndex += 1;
  return 'row-' + rowIndex;
}